import React from "react";
import partner1 from "../../assets/partner/palm-smart-chain-logo.png";
import partner2 from "../../assets/partner/thinker-technology-logo.png";
import partner3 from "../../assets/partner/aman-logo.png";
import partner4 from "../../assets/partner/peafx-logo.png";
import partner5 from "../../assets/partner/thinkertech-logo.png";

const WeHavePartnered = () => {
    return (
        <div className="bg-[#fff]">
            <div className="container mx-auto px-4 overflow-hidden">
                <div className="py-20">
                    <div className="text-center">
                        <h2 className="text-6xl font-bold text-[#6540b2]">
                            We have <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#fb6a2b] to-[#e83f3b]">partnered</span> with
                            <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#fb6a2b] to-[#e83f3b]">top</span> finance companies
                        </h2>
                    </div>

                    <div class="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)] mt-20">
                        <ul class="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
                            <li>
                                <img src={partner1} alt="palm-smart-chain-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner2} alt="thinker-technology-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner3} alt="aman-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner4} alt="peafx-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner5} alt="thinkertech" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner1} alt="palm-smart-chain-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner2} alt="thinker-technology-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner3} alt="aman-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                        </ul>
                        <ul class="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll" aria-hidden="true">
                            <li>
                                <img src={partner1} alt="palm-smart-chain-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner2} alt="thinker-technology-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner3} alt="aman-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner4} alt="peafx-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner5} alt="thinkertech" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner1} alt="thinker-technology-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner2} alt="thinker-technology-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                            <li>
                                <img src={partner3} alt="aman-logo" className="hover:scale-[1.2] cursor-pointer transition-all w-[100px] h-[100%] object-contain" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeHavePartnered;
